module.exports = __webpack_public_path__ + "img/zh.f3f15289.png";